<template>
	<div class="tpl comment-list-wrap">
		<mt-header title="评论" fixed>
			<router-link :to="{name:'trend-notice',query:{selected:selected}}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="comment-list">
			<mt-loadmore :top-method="refreshCommentList" :bottom-method="loadMoreCommentList" :auto-fill="false" ref="loadmorecomment">
			<ul>
				<li v-for="item in listInfo" @click="goToTrendDetail(item.d_id,item.type)">
					<div class="item-info">
						<div class="item-avatar">
							<img :src="item.avatar" alt="" />
						</div>
						<div class="item-intro">
							<p class="item-name">
								{{item.nickname}}
								<img v-if="item.is_vip==1" src="../../assets/img/common/ic_user_vip@2x.png" alt="" />
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png" alt="" />
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png" alt="" />
							</p>
							<p class="item-text">{{item.c_text}}</p>
							<p class="item-time">{{item.create_time}}</p>
						</div>
					</div>
					<div class="item-preview">
						<div class="img" v-if="item.type==1">
							<img :src="item.attach" alt="" />
						</div>
						<div class="text" v-if="item.type<=0">
							{{item.text}}
						</div>
						<div class="video" v-if="item.type==2">
							<img :src="item.attach" alt="" />
							<img class="btn-play" src="../../assets/img/trends/dyn_dyn_ic_video.png" alt="" />
						</div>
					</div>
				</li>
			</ul>
			</mt-loadmore>
		</div>
	</div>
</template>

<script>
	export default{
		name:"comment-list",
		data(){
			return{
				uid:"",
				selected:"",
				listInfo:"",
				nowPage:1,
			}
		},
		created(){
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "trends");
			this.$store.commit("changeTabBarShow", false);

			this.selected = this.$route.query.selected;
			
			this.getList();
		},
		methods:{
			getList(){
				if(!this.isLogin()){return false;}
				this.$axios({
					url:"Dynamic/getCommentList",
					method:"post",
					data:{
						uid:this.uid,
						page:this.nowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.nowPage==1){
							this.$toast({
								message:"加载成功~",
								position:"bottom",
								duration:3000
							})
							this.listInfo = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.nowPage--;
							}else{
								this.$toast({
									message:"加载成功~",
									position:"bottom",
									duration:3000
								})
								this.listInfo = this.listInfo.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.nowPage--;
					}
				}).catch(err=>{
					console.log(err);
					this.$toast({
							message: "加载失败！",
							position: "bottom",
							duration: 3000
						});
				})
			},
			goToTrendDetail(id,s){
				if(s==-1){
					this.$router.push({
						name:"tree-hole-detail",
						query:{
							id:id,
							selected:'3'
						}
					})
				}else{
					this.$router.push({
						name:"trend-detail",
						query:{
							id:id,
							selected:'1'
						}
					})
				}
			},
			refreshCommentList(){
				this.nowPage = 1;
				this.getList();
				this.$refs.loadmorecomment.onTopLoaded();
			},
			loadMoreCommentList(){
				this.nowPage++;
				this.getList();
				this.$refs.loadmorecomment.onBottomLoaded();
			},
		}
	}
</script>

<style scoped>
	.comment-list-wrap{
		padding-top: 2.5rem;
		background: #fff;
	}
	.comment-list{
		height: calc(100vh - 2.5rem);
		overflow-y: scroll;
	}
	.comment-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.comment-list li:active{
		background: #fafafa;
	}
	.comment-list li .item-avatar img{
		width: 3rem;
		height: 3rem;
		display: block;
		border-radius: 50%;
	}
	.comment-list li .item-preview img{
		width: 4rem;
	}
	.comment-list li .item-info{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex: 1;
	}
	.comment-list li .item-name{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		padding: 0 0.5rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.comment-list li .item-name img{
		width: 1.5rem;
	}
	.comment-list li .item-text{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		font-size: 0.8rem;
		color: #282828;
		padding: 0 0.5rem;
		margin: 3px 0;
	}
	.comment-list li .item-time{
		font-size: 0.8rem;
		color: #7b7b7b;
		padding: 0 0.5rem;
	}
	.comment-list li .item-preview{
		width: 4rem;
		height: 4rem;
		background: #f3f3f3;
		overflow: hidden;
		font-size: 0.65rem;
		color: #7b7b7b;
		display:flex;
		justify-content: center;
		align-items: center;
	}
	.comment-list li .item-preview .img img{
		width: 4rem;
		display: block;
	}
	.comment-list li .item-preview .text{
		padding: 0.5rem;
	}
	.comment-list li .item-preview .video{
		position: relative;
		width: 100%;
		height: 100%;
	}
	.comment-list li .item-preview .video .btn-play{
		width: 1.5rem;
		height: 1.5rem;
		position: absolute;
		left: 33%;
		top: 33%;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/CommentList.vue